// extracted by mini-css-extract-plugin
export default {"map_box":"style_map_box__W+iVx"};